// extracted by mini-css-extract-plugin
export var couponCard = "styles-module__couponCard___FVyDq";
export var giftInputs = "styles-module__giftInputs___KxAxi";
export var actionButton = "styles-module__actionButton___wXOhs";